import { FormikActions } from 'formik';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import withStyles from '@material-ui/core/styles/withStyles';
import Switch from '@material-ui/core/Switch';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { expandConfigView, expandWebhookView } from '../actions/app';
import { generateWebhook, installSchema, saveCriteria } from '../actions/config';
import CriteriaForm from '../components/criteria-form';
import WebhookForm from '../components/webhook-form';
import { styles } from '../style';
import { IApp } from '../types/app';

class DatafinitiContent extends React.Component<IApp | any, any> {
  public render() {
    console.log('DatafinitiContent', this.props)

    const { classes } = this.props;
    return (
      <div style={this.props.style}>
        <Tooltip title='When enabled, this indicates the schema has been installed for this integration'>
          <FormControlLabel
            label='Schema Installed'
            control={
              <Switch checked={this.props.config.enabled} value='installed' onClick={this.toggleInstallSchema} />
            }
          />
        </Tooltip>
        <ExpansionPanel expanded={this.props.app.configuredExpanded} onChange={this.togleExpandConfig} disabled={!this.props.config.enabled}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>Configure Data Collector</Typography>
            <Typography className={classes.secondaryHeading}>Configure Datafiniti settings</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <CriteriaForm style={{width: '100%'}} onSubmit={this.saveCriteria}/>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel expanded={this.props.app.webhookExpanded} onChange={this.toggleExpandWebhook} disabled={!this.props.config.enabled}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>Webhook</Typography>
            <Typography className={classes.secondaryHeading}>Information about webhook trigger to this integration.</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <WebhookForm style={{width: '100%'}} generateWebhook={this.generateWebhook}/>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </div >
    );
  }
  private toggleInstallSchema = () => {
    const accessToken = this.props.authentication.session.id
    const tenantId = this.props.tenant.id
    this.props.dispatch(installSchema(
      accessToken,
      tenantId,
      !this.props.config.enabled,
    ))
  }
  private togleExpandConfig = () => this.props.dispatch(expandConfigView(!this.props.app.configuredExpanded))
  private toggleExpandWebhook = () => this.props.dispatch(expandWebhookView(!this.props.app.webhookExpanded))

  private saveCriteria = (values: any, actions: FormikActions<any>) => {
    const accessToken = this.props.authentication.session.id
    const tenantId = this.props.tenant.id
    this.props.dispatch(saveCriteria(
      accessToken,
      tenantId,
      JSON.parse(values.criteria),
    ))
  }
  private generateWebhook = () => {
    const accessToken = this.props.authentication.session.id
    const tenantId = this.props.tenant.id
    this.props.dispatch(generateWebhook(
      accessToken,
      tenantId,
    ))
  }
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default withStyles(styles)(withRouter(connect(
  mapStateToProps,
)(DatafinitiContent)));



// WEBPACK FOOTER //
// ./src/sub-projects/datafiniti/containers/content.tsx